import { gql } from 'graphql-request';

export const SETTINGS_FIELDS = gql`
  fragment SettingsFields on SettingsDto {
    settingId
    name
    value
    description
  }
`;

export const GET_ALL_SETTINGS = gql`
  query GetAllSettings {
    settings {
      ...SettingsFields
    }
  }
  ${SETTINGS_FIELDS}
`;

export const GET_SETTING = gql`
  query GetSetting($settingId: String!) {
    setting(settingId: $settingId) {
      ...SettingsFields
    }
  }
  ${SETTINGS_FIELDS}
`;

export const CREATE_SETTING = gql`
  mutation CreateSetting($input: SettingCreateInput!) {
    createSetting(input: $input) {
      ...SettingsFields
    }
  }
  ${SETTINGS_FIELDS}
`;

export const UPDATE_SETTING = gql`
  mutation UpdateSetting($settingId: String!, $input: SettingUpdateInput!) {
    updateSetting(settingId: $settingId, input: $input) {
      ...SettingsFields
    }
  }
  ${SETTINGS_FIELDS}
`;

export const DELETE_SETTING = gql`
  mutation DeleteSetting($settingId: String!) {
    deleteSetting(settingId: $settingId)
  }
`;

const SettingsGraphQL = {
  queries: {
    getAllSettings: GET_ALL_SETTINGS,
    getSetting: GET_SETTING,
  },
  mutations: {
    createSetting: CREATE_SETTING,
    updateSetting: UPDATE_SETTING,
    deleteSetting: DELETE_SETTING,
  },
};

export default SettingsGraphQL;
